import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, ViewChild, HostListener, Inject, forwardRef, HostBinding, NgModule } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i2$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatSliderModule } from '@angular/material/slider';
import * as i2 from '@angular/material/tabs';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import * as i6 from '@angular/forms';
import { NgControl, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import * as i2$2 from '@firestitch/clear';
import { FsClearModule } from '@firestitch/clear';
import Color from 'color';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

class ColorPaletteComponent {
    constructor() {
        this.changed = new EventEmitter(true);
        this.colorStyle = {};
        this.mousedown = false;
    }
    onMouseUp(evt) {
        this.mousedown = false;
    }
    onMouseMove(evt) {
        this.mouseMove(evt);
    }
    ngOnInit() {
        this.drawHandle();
    }
    ngOnChanges(changes) {
        if (changes.color) {
            if (!this.selectedPosition) {
                this.selectedPosition = { x: 0, y: 0 };
            }
            const hsv = this.color.hsv();
            this.selectedPosition = { x: (hsv.color[1] / 100) * 255, y: 255 - ((hsv.color[2] / 100) * 255) };
            const background = Color(this.color).hsv();
            background.color[1] = 100;
            background.color[2] = 100;
            this.colorStyle.background = background.hex();
            this.drawHandle();
        }
    }
    drawHandle() {
        if (this.selectedPosition) {
            this.handle = this.handleCanvas.nativeElement.getContext('2d');
            const width = this.handleCanvas.nativeElement.width;
            const height = this.handleCanvas.nativeElement.height;
            this.handle.clearRect(0, 0, width, height);
            this.handle.strokeStyle = 'rgba(255, 255, 255, 0.5)';
            this.handle.beginPath();
            this.handle.arc(this.selectedPosition.x, this.selectedPosition.y, 10, 0, 2 * Math.PI);
            this.handle.lineWidth = 5;
            this.handle.stroke();
        }
    }
    canvasMouseDown(evt) {
        this.mousedown = true;
        this.rect = this.colorLayer.nativeElement.getBoundingClientRect();
        this.onMouseMove(evt);
    }
    mouseMove(event) {
        if (this.mousedown) {
            event.stopPropagation();
            event.preventDefault();
            const top = this.rect.top;
            const left = this.rect.left;
            const height = top + this.colorLayer.nativeElement.clientHeight;
            const width = left + this.colorLayer.nativeElement.clientWidth;
            let y = event.pageY;
            let x = event.pageX;
            if (event.pageY < top) {
                y = top;
            }
            if (event.pageY > (height)) {
                y = height;
            }
            if (event.pageX < left) {
                x = left;
            }
            if (event.pageX > (width)) {
                x = width - 1;
            }
            x = this.handleCanvas.nativeElement.width - (width - x);
            y = this.handleCanvas.nativeElement.height - (height - y);
            this.selectedPosition = { x, y };
            this.drawHandle();
            const hsl = this.color.hsl();
            let s = x / 255;
            const h = 1 - (y / 255);
            const l = (h / 2) * (2 - s);
            s = (h * s) / (1 - Math.abs(2 * l - 1));
            hsl.color[1] = (s * 100) || 0;
            hsl.color[2] = l * 100;
            this.color = hsl;
            this.changed.emit(this.color);
        }
    }
}
ColorPaletteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ColorPaletteComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ColorPaletteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ColorPaletteComponent, selector: "cp-color-palette", inputs: { selectedPosition: "selectedPosition", color: "color" }, outputs: { changed: "changed" }, host: { listeners: { "window:mouseup": "onMouseUp($event)", "window:mousemove": "onMouseMove($event)" } }, viewQueries: [{ propertyName: "handleCanvas", first: true, predicate: ["handle"], descendants: true, static: true }, { propertyName: "colorLayer", first: true, predicate: ["colorLayer"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"color\" #colorLayer [ngStyle]=\"colorStyle\"></div>\n<div class=\"white\"></div>\n<div class=\"black\"></div>\n\n<canvas \n        #handle\n        class=\"handle\"\n        width=\"255\"\n        height=\"255\"\n        (mousedown)=\"canvasMouseDown($event)\">\n</canvas>\n", styles: [".color-palette:hover{cursor:pointer}:host{width:255px;height:255px;display:block;margin-right:7px;position:relative}.handle{position:absolute;top:0;left:0}.black,.white,.color{width:255px;height:255px;position:absolute;top:0;left:0}.black{background:linear-gradient(to top,#000,rgba(0,0,0,0))}.white{background:linear-gradient(to right,#fff,rgba(255,255,255,0))}\n"], directives: [{ type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ColorPaletteComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cp-color-palette',
                    templateUrl: './color-palette.component.html',
                    styleUrls: ['./color-palette.component.css'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { selectedPosition: [{
                type: Input
            }], color: [{
                type: Input
            }], changed: [{
                type: Output
            }], handleCanvas: [{
                type: ViewChild,
                args: ['handle', { static: true }]
            }], colorLayer: [{
                type: ViewChild,
                args: ['colorLayer', { static: true }]
            }], onMouseUp: [{
                type: HostListener,
                args: ['window:mouseup', ['$event']]
            }], onMouseMove: [{
                type: HostListener,
                args: ['window:mousemove', ['$event']]
            }] } });

function isContrastYIQDark(rgb, limit = 180) {
    const yiq = ((rgb.red() * 299) + (rgb.green() * 587) + (rgb.blue() * 114)) / 1000;
    return yiq >= limit;
}

class HueSliderComponent {
    constructor() {
        this.changed = new EventEmitter();
        this.height = 255;
        this.width = 30;
        this._colorDragging = false;
        this._alphaDragging = false;
        this._destroy$ = new Subject();
        fromEvent(window, 'mouseup')
            .pipe(takeUntil(this._destroy$)).subscribe(() => {
            this._colorDragging = false;
            this._alphaDragging = false;
        });
        fromEvent(window, 'mousemove')
            .pipe(takeUntil(this._destroy$))
            .subscribe((event) => {
            if (this._colorDragging) {
                this.colorMove(event.clientY - this.colorCanvas.nativeElement.getBoundingClientRect().top);
            }
            if (this._alphaDragging) {
                this.alphaMove(event.clientY - this.alphaCanvas.nativeElement.getBoundingClientRect().top);
            }
        });
    }
    ngOnInit() {
        this.colorTop = `${(this.color.hsl().hue() / 360) * this.height}px`;
        this.alphaTop = `${(1 - this.color.alpha()) * this.height}px`;
        this.draw();
    }
    draw() {
        this.drawColor();
        this.drawAlpha();
    }
    drawColor() {
        this.ctx = this.colorCanvas.nativeElement.getContext('2d');
        const width = this.colorCanvas.nativeElement.width;
        const height = this.colorCanvas.nativeElement.height;
        this.ctx.clearRect(0, 0, width, height);
        const gradient = this.ctx.createLinearGradient(0, 0, 0, height);
        gradient.addColorStop(0, 'rgba(255, 0, 0, 1)');
        gradient.addColorStop(0.17, 'rgba(255, 255, 0, 1)');
        gradient.addColorStop(0.34, 'rgba(0, 255, 0, 1)');
        gradient.addColorStop(0.51, 'rgba(0, 255, 255, 1)');
        gradient.addColorStop(0.68, 'rgba(0, 0, 255, 1)');
        gradient.addColorStop(0.85, 'rgba(255, 0, 255, 1)');
        gradient.addColorStop(1, 'rgba(255, 0, 0, 1)');
        this.ctx.beginPath();
        this.ctx.rect(0, 0, width, height);
        this.ctx.fillStyle = gradient;
        this.ctx.fill();
        this.ctx.closePath();
    }
    drawAlpha() {
        this.alphaContext = this.alphaCanvas.nativeElement.getContext('2d');
        const hueGrd = this.alphaContext.createLinearGradient(90, 0.000, 90, this.height);
        hueGrd.addColorStop(0.01, 'rgba(' + this.color.red() + ',' + this.color.green() + ',' + this.color.blue() + ', 1.000)');
        hueGrd.addColorStop(0.99, 'rgba(' + this.color.red() + ',' + this.color.green() + ',' + this.color.blue() + ', 0.000)');
        this.alphaContext.clearRect(0, 0, 30, this.height);
        this.alphaContext.fillStyle = hueGrd;
        this.alphaContext.fillRect(0, 0, 30, this.height);
    }
    colorMouseDown(event) {
        this._colorDragging = true;
        this.colorMove(event.offsetY);
    }
    colorMove(height) {
        if (height < 0) {
            height = 0;
        }
        else if (height > 255) {
            height = 255;
        }
        this.color = this.color.hsl();
        this.color.color[0] = ((height) / this.height) * 360;
        this.drawAlpha();
        this.colorHandle.nativeElement.style.top = `${height}px`;
        this.changed.emit(this.color);
    }
    alphaMove(height) {
        if (height < 0) {
            height = 0;
        }
        else if (height > 255) {
            height = 255;
        }
        const alpha = Math.round((1 - (height / this.height)) * 100) / 100;
        this.color = this.color.alpha(alpha);
        this.alphaHandle.nativeElement.style.top = `${height}px`;
        this.changed.emit(this.color);
    }
    alphaMouseDown(event) {
        this._alphaDragging = true;
        this.alphaMove(event.offsetY);
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
HueSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: HueSliderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HueSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: HueSliderComponent, selector: "cp-hue-slider", inputs: { color: "color" }, outputs: { changed: "changed" }, viewQueries: [{ propertyName: "colorCanvas", first: true, predicate: ["colorCanvas"], descendants: true, static: true }, { propertyName: "colorHandle", first: true, predicate: ["colorHandle"], descendants: true, static: true }, { propertyName: "alphaCanvas", first: true, predicate: ["alphaCanvas"], descendants: true, static: true }, { propertyName: "alphaHandle", first: true, predicate: ["alphaHandle"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"sliders\">\n  <div\n      class=\"slider-container slider-color\"\n      (mousedown)=\"colorMouseDown($event)\">\n    <div\n      #colorHandle\n      [style.top]=\"colorTop\"\n      class=\"handle\">\n    </div>\n    <canvas\n      #colorCanvas\n      width=\"30\"\n      height=\"255\">\n    </canvas>\n  </div>\n\n  <div\n      class=\"slider-container slider-alpha\"\n      (mousedown)=\"alphaMouseDown($event)\">\n    <div class=\"background\"></div>\n    <div\n      #alphaHandle\n      class=\"handle\"\n      [style.top]=\"alphaTop\">\n    </div>\n    <canvas\n      #alphaCanvas\n      width=\"30\"\n      height=\"255\">\n    </canvas>\n  </div>\n</div>\n", styles: [":host{height:255px;position:relative}.sliders{display:flex;flex-direction:row}.sliders .slider-container{width:30px;height:255px;margin-right:3px;position:relative;cursor:pointer}.sliders .slider-container canvas{border-radius:4px}.sliders .slider-container.slider-alpha .background{height:100%;width:100%;border-radius:4px;position:absolute;top:0;background-image:linear-gradient(to right,rgba(228,228,228,.75),rgba(228,228,228,.75)),linear-gradient(to right,black 50%,white 50%),linear-gradient(to bottom,black 50%,white 50%);background-blend-mode:normal,difference,normal;background-size:6px 6px}.sliders .slider-container.slider-alpha canvas{z-index:1;position:relative}.sliders .slider-container:last-child{margin-right:0}.sliders .slider-container .handle{pointer-events:none;cursor:pointer;z-index:2;position:absolute;top:0;left:0;width:30px;box-sizing:border-box;height:2px}.sliders .slider-container .handle:before{content:\" \";border:2px solid white;position:absolute;top:-5px;width:100%;left:0;box-sizing:border-box}.sliders .slider-container .handle:after{content:\" \";border:2px solid white;position:absolute;top:1px;width:100%;left:0;box-sizing:border-box}.none{border:1px solid #ccc;height:30px;border-radius:50%;width:30px;z-index:1;overflow:hidden;position:relative;box-sizing:border-box}.none span{width:43px;border-bottom:3px solid #FA6E7E;transform:rotate(-45deg);position:absolute;top:14px;left:-9px;z-index:0}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: HueSliderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cp-hue-slider',
                    templateUrl: './hue-slider.component.html',
                    styleUrls: ['./hue-slider.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { color: [{
                type: Input
            }], changed: [{
                type: Output
            }], colorCanvas: [{
                type: ViewChild,
                args: ['colorCanvas', { static: true }]
            }], colorHandle: [{
                type: ViewChild,
                args: ['colorHandle', { static: true }]
            }], alphaCanvas: [{
                type: ViewChild,
                args: ['alphaCanvas', { static: true }]
            }], alphaHandle: [{
                type: ViewChild,
                args: ['alphaHandle', { static: true }]
            }] } });

function isHexValue(value) {
    const hexRegex = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    return !!value.match(hexRegex);
}

class DialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.paletteColor = null;
        this.colorHex = '';
        this.colorRgb = '';
        this.contrastColor = '';
        this.showClear = false;
        this.color = Color();
    }
    ngOnInit() {
        const color = this.data.color || '#000000';
        this.showClear = this.data.showClear;
        this.setColor(color);
        this.paletteColor = this.color;
    }
    setColor(color) {
        this.color = Color(color);
        this.colorHex = this.getHex();
        this.colorRgb = this.color.rgb().toString();
        this.contrastColor = isContrastYIQDark(this.color.rgb()) ? '#474747' : '#fff';
    }
    alphaToHex(alpha) {
        if (alpha >= 1 || alpha < 0 || isNaN(alpha)) {
            return '';
        }
        return Math.ceil(255 * alpha).toString(16).toUpperCase();
    }
    rgbChanged() {
        const match = this.colorRgb.match(/rgb\(\d+\s*,\s*\d+\s*,\s*\d+\s*\)/i);
        if (match) {
            this.setColor(this.colorRgb);
            this.paletteColor = this.color;
        }
    }
    hexChanged() {
        let hex = this.colorHex;
        if (isHexValue(hex)) {
            if (!this.colorHex.startsWith('#')) {
                hex = `#${this.colorHex}`;
            }
            this.setColor(hex);
            this.paletteColor = this.color;
        }
    }
    sliderChanged(color) {
        this.setColor(color);
        this.paletteColor = color;
    }
    paletteChanged(color) {
        this.setColor(color);
        this.hueSlider.drawAlpha();
    }
    clear() {
        this.dialogRef.close(null);
    }
    select() {
        this.dialogRef.close(this.getHex());
    }
    getHex() {
        let hex = this.color.hex();
        if (this.color.alpha() < 1) {
            let alpha = this.alphaToHex(this.color.alpha());
            if (alpha.length === 1) {
                alpha = `0${alpha}`;
            }
            hex = hex.concat(alpha);
        }
        return hex;
    }
    pasted(event) {
        if (this._tabGroup.selectedIndex !== 0) {
            return;
        }
        event.preventDefault();
        let insertion = event.clipboardData.getData('text');
        if (isHexValue(insertion)) {
            if (!insertion.startsWith('#')) {
                insertion = `#${insertion}`;
            }
            this.colorHex = insertion;
            this.hexChanged();
        }
    }
}
DialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DialogComponent, deps: [{ token: i1.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
DialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: DialogComponent, selector: "cp-dialog", viewQueries: [{ propertyName: "hueSlider", first: true, predicate: HueSliderComponent, descendants: true, static: true }, { propertyName: "_tabGroup", first: true, predicate: MatTabGroup, descendants: true, static: true }], ngImport: i0, template: "<div class=\"header\">\n  <mat-tab-group headerPosition=\"below\" [style.background]=\"colorRgb\" [style.color]=\"contrastColor\">\n    <mat-tab label=\"HEX\">\n      <div class=\"color\" >\n        <input [(ngModel)]=\"colorHex\"\n               name=\"color-hex\"\n               [style.color]=\"contrastColor\"\n               (ngModelChange)=\"hexChanged()\"\n               (paste)=\"pasted($event)\"\n               (keydown.enter)=\"select()\">\n      </div>\n    </mat-tab>\n    <mat-tab label=\"RGB\">\n      <div class=\"color\" >\n        <input [(ngModel)]=\"colorRgb\" name=\"color-rgb\" [style.color]=\"contrastColor\" (ngModelChange)=\"rgbChanged()\">\n      </div>\n    </mat-tab>\n  </mat-tab-group>\n</div>\n\n<div class=color-wrapper>\n  <cp-color-palette [color]=\"paletteColor\" (changed)=\"paletteChanged($event)\"></cp-color-palette>\n  <cp-hue-slider [color]=\"color\" (changed)=\"sliderChanged($event)\"></cp-hue-slider>\n</div>\n\n<div class=\"buttons\">\n  <button mat-button color=\"primary\" (click)=\"select()\">Select</button>\n  <ng-container *ngIf=\"showClear\">\n    <button mat-button (click)=\"clear()\">Clear</button>\n  </ng-container>\n  <button mat-button [mat-dialog-close]=\"undefined\">Cancel</button>  \n</div>\n", styles: [":host{display:inline-block}:host ::ng-deep .mat-tab-label{min-width:0;width:50%;color:unset;opacity:.45}:host ::ng-deep .mat-tab-label.mat-tab-label-active{opacity:1}:host ::ng-deep .header{background-image:linear-gradient(to right,rgba(228,228,228,.75),rgba(228,228,228,.75)),linear-gradient(to right,black 50%,white 50%),linear-gradient(to bottom,black 50%,white 50%);background-blend-mode:normal,difference,normal;background-size:10px 10px}:host ::ng-deep mat-tab-group input{padding:15px;text-align:center;font-size:20px;width:100%;border:none;background:transparent;box-sizing:border-box;outline:none}:host ::ng-deep .mat-tab-group-inverted-header .mat-tab-nav-bar,:host ::ng-deep .mat-tab-group-inverted-header .mat-tab-header{border:none}:host ::ng-deep .mat-tab-group.mat-primary .mat-ink-bar,:host ::ng-deep .mat-tab-nav-bar.mat-primary .mat-ink-bar{background:unset}.color-wrapper{display:flex;flex-direction:row;justify-content:center;padding:7px;-webkit-user-select:none;user-select:none}.color-wrapper app-color-palette{margin-right:7px}.buttons{padding:0 7px 7px;display:flex;flex-direction:row}.buttons button{width:50%}.buttons button+button{margin-left:5px}\n"], components: [{ type: i2.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { type: i2.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby"], exportAs: ["matTab"] }, { type: ColorPaletteComponent, selector: "cp-color-palette", inputs: ["selectedPosition", "color"], outputs: ["changed"] }, { type: HueSliderComponent, selector: "cp-hue-slider", inputs: ["color"], outputs: ["changed"] }, { type: i5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["type", "mat-dialog-close", "aria-label", "matDialogClose"], exportAs: ["matDialogClose"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cp-dialog',
                    templateUrl: './dialog.component.html',
                    styleUrls: ['./dialog.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; }, propDecorators: { hueSlider: [{
                type: ViewChild,
                args: [HueSliderComponent, { static: true }]
            }], _tabGroup: [{
                type: ViewChild,
                args: [MatTabGroup, { static: true }]
            }] } });

class FsColorPickerChipComponent {
    constructor(_dialog, _cdRef) {
        this._dialog = _dialog;
        this._cdRef = _cdRef;
        this.showClear = true;
        this.changed = new EventEmitter();
        this._color = void 0;
        this._destroy$ = new Subject();
    }
    set color(value) {
        this._color = value;
        this._updateBorder();
    }
    ngOnInit() {
        this._updateBorder();
        this._cdRef.detectChanges();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    clear() {
        this.color = null;
        this._cdRef.markForCheck();
    }
    get color() {
        return this._color;
    }
    openDialog() {
        const dialogRef = this._dialog.open(DialogComponent, {
            data: {
                color: this._color,
                showClear: this.showClear,
            },
            panelClass: 'fs-color-picker-dialog-container'
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe((result) => {
            if (result !== undefined) {
                this.color = result;
                this.changed.next(this.color);
                this._cdRef.markForCheck();
            }
        });
    }
    _updateBorder() {
        this.borderColor = null;
        if (this.color) {
            const color = Color(this.color);
            if (isContrastYIQDark(color.rgb(), 220) || color.alpha() < .2) {
                this.borderColor = '#e4e4e4';
            }
        }
    }
}
FsColorPickerChipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsColorPickerChipComponent, deps: [{ token: i1.MatDialog }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsColorPickerChipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsColorPickerChipComponent, selector: "fs-color-picker-chip", inputs: { color: "color", showClear: "showClear" }, outputs: { changed: "changed" }, ngImport: i0, template: "<div class=\"chip-container\">\n  <div\n    class=\"chip\"\n    [ngStyle]=\"{\n      background: color,\n      borderColor: borderColor\n    }\"\n    (click)=\"openDialog()\">\n  </div>\n  <div [ngClass]=\"{ 'has-color': !!color }\" class=\"color\">\n    <ng-container *ngIf=\"!color\">\n      <mat-icon>format_color_reset</mat-icon>\n    </ng-container>\n  </div>\n</div>\n", styles: [".chip-container{outline:none;position:relative;display:block;height:22px;width:22px;-webkit-user-select:none;user-select:none}.chip-container .chip{width:100%;height:100%;border-radius:50%;cursor:pointer;position:relative;border:1px solid transparent;z-index:1;transform:rotate(-45deg)}.chip-container .color{position:absolute;top:0px;width:100%;height:100%}.chip-container .color mat-icon{color:#d4d4d4}::ng-deep .fs-color-picker-dialog-container .mat-dialog-container{padding:0}\n"], components: [{ type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsColorPickerChipComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-color-picker-chip',
                    templateUrl: 'color-picker-chip.component.html',
                    styleUrls: ['color-picker-chip.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialog }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { color: [{
                type: Input
            }], showClear: [{
                type: Input
            }], changed: [{
                type: Output
            }] } });

class FsColorPickerComponent {
    constructor(_injector, _el, _renderer2, _cdRef) {
        this._injector = _injector;
        this._el = _el;
        this._renderer2 = _renderer2;
        this._cdRef = _cdRef;
        this.showClear = true;
        this.tabindex = '-1';
        this.autocomplete = 'off';
        this._isDisabled = false;
        this._destroy$ = new Subject();
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
        this.updateInput();
    }
    get isDisabled() {
        return this._isDisabled;
    }
    inputClick($event) {
        // To prevent open dialog if used in preview mode or disabled
        if (!this._ngControl || this._isDisabled) {
            return;
        }
        if (!this.value) {
            $event.preventDefault();
            $event.stopPropagation();
            $event.stopImmediatePropagation();
        }
        this.openDialog();
    }
    ngOnInit() {
        this._ngControl = this._injector.get(NgControl);
        // If in preview mode
        if (!this._ngControl) {
            this.showClear = false;
            this._isDisabled = true;
        }
        this._cdRef.markForCheck();
    }
    ngAfterViewInit() {
        if (this._ngControl) {
            this._renderer2.setAttribute(this._el.nativeElement, 'readonly', 'readonly');
            const el = this._getFormFieldFlex(this._el.nativeElement);
            if (el) {
                const wrapper = this._el.nativeElement.querySelector('.fs-color-picker-preview-wrapper');
                const prefix = document.createElement('div');
                prefix.classList.add('mat-form-field-prefix');
                prefix.append(wrapper);
                el.prepend(prefix);
            }
        }
    }
    _getFormFieldFlex(el) {
        if (el.classList.contains('mat-form-field-flex')) {
            return el;
        }
        return el.parentElement ? this._getFormFieldFlex(el.parentElement) : null;
    }
    writeValue(value) {
        this._value = value;
        this.updateInput();
        this._cdRef.markForCheck();
    }
    updateInput() {
        this._el.nativeElement.value = this.value || '';
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this._isDisabled = isDisabled;
        this._cdRef.markForCheck();
    }
    chipChanged(color) {
        this.value = color;
        this._onChange(color);
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    clear(event) {
        event.stopPropagation();
        this.chipChanged(null);
        this.colorChip.clear();
    }
    openDialog() {
        if (this._isDisabled) {
            return;
        }
        this.colorChip.openDialog();
    }
}
FsColorPickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsColorPickerComponent, deps: [{ token: i0.Injector }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsColorPickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsColorPickerComponent, selector: "[fsColorPicker]", inputs: { showClear: "showClear" }, host: { listeners: { "click": "inputClick($event)" }, properties: { "attr.tabindex": "this.tabindex", "attr.autocomplete": "this.autocomplete" } }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FsColorPickerComponent),
            multi: true,
        }], viewQueries: [{ propertyName: "colorChip", first: true, predicate: FsColorPickerChipComponent, descendants: true, static: true }], ngImport: i0, template: "<div class=\"fs-color-picker-preview-wrapper\" [ngClass]=\"{ selected: value, disabled: isDisabled }\">\n  <fs-color-picker-chip\n    [color]=\"value\"\n    [showClear]=\"false\"\n    (changed)=\"chipChanged($event)\">\n  </fs-color-picker-chip>\n</div>\n\n<fs-clear\n  (clear)=\"clear($event)\"\n  [show]=\"showClear\"\n  [visible]=\"!!value\">\n</fs-clear>\n", styles: [":host{outline:none}.fs-color-picker-preview-wrapper{margin-right:6px}.fs-color-picker-preview-wrapper.disabled{cursor:default}::ng-deep .fs-color-picker-dialog-container .mat-dialog-container{padding:0}\n"], components: [{ type: FsColorPickerChipComponent, selector: "fs-color-picker-chip", inputs: ["color", "showClear"], outputs: ["changed"] }, { type: i2$2.FsClearElementComponent, selector: "fs-clear", inputs: ["show", "visible"], outputs: ["clear"] }], directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsColorPickerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[fsColorPicker]',
                    templateUrl: './color-picker.component.html',
                    styleUrls: ['./color-picker.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FsColorPickerComponent),
                            multi: true,
                        }],
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { colorChip: [{
                type: ViewChild,
                args: [FsColorPickerChipComponent, { static: true }]
            }], showClear: [{
                type: Input
            }], tabindex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], autocomplete: [{
                type: HostBinding,
                args: ['attr.autocomplete']
            }], inputClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class FsColorPickerModule {
}
FsColorPickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsColorPickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsColorPickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsColorPickerModule, declarations: [DialogComponent,
        FsColorPickerChipComponent,
        HueSliderComponent,
        ColorPaletteComponent,
        FsColorPickerComponent], imports: [FormsModule,
        CommonModule,
        DragDropModule,
        MatTabsModule,
        MatSliderModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        FsClearModule], exports: [DialogComponent,
        FsColorPickerComponent,
        FsColorPickerChipComponent] });
FsColorPickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsColorPickerModule, imports: [[
            FormsModule,
            CommonModule,
            DragDropModule,
            MatTabsModule,
            MatSliderModule,
            MatDialogModule,
            MatButtonModule,
            MatIconModule,
            FsClearModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsColorPickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        CommonModule,
                        DragDropModule,
                        MatTabsModule,
                        MatSliderModule,
                        MatDialogModule,
                        MatButtonModule,
                        MatIconModule,
                        FsClearModule
                    ],
                    exports: [
                        DialogComponent,
                        FsColorPickerComponent,
                        FsColorPickerChipComponent
                    ],
                    entryComponents: [
                        DialogComponent,
                    ],
                    declarations: [
                        DialogComponent,
                        FsColorPickerChipComponent,
                        HueSliderComponent,
                        ColorPaletteComponent,
                        FsColorPickerComponent
                    ]
                }]
        }] });

function randomColor() {
    const color = Color().hsv();
    color.color[0] = Math.floor(Math.random() * 360);
    color.color[1] = Math.floor(Math.random() * (10) + 80);
    color.color[2] = Math.floor(Math.random() * (10) + 80);
    return color.hex();
}

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DialogComponent, FsColorPickerChipComponent, FsColorPickerComponent, FsColorPickerModule, randomColor };
